import {
    selectedRecordsField,
    updatedRecordsField,
} from 'app/shared-components/SimpleBulkUpload/SimpleBulkUpload.utils'
import {
    FeedbackFormFields,
    UpdateFormFields,
} from 'app/shared-components/SimpleBulkUpload/SimpleBulkUpload.types'
import {
    FieldInCard,
} from 'app/types/form.types'

import availableLoggerStatuses from '../Logger/Logger.utils'
import {
    LoggerBulkUploadFormValues,
    UpdateField,
} from './LoggerBulkUploadPopup.types'
import {
    updateFieldValues,
} from './LoggerBulkUploadPopup.utils'

const updateToFieldMap: Record<UpdateField, FieldInCard<keyof LoggerBulkUploadFormValues>> = {
    [UpdateField.RentingCompany]: {
        name: 'updateTo',
        labelKey: 'BulkUpload.updateTo',
        componentName: 'CompanyObjectSelector',
        useDropdown: true,
        required: true,
    },
    [UpdateField.LoggerStatus]: {
        name: 'updateTo',
        labelKey: 'BulkUpload.updateTo',
        componentName: 'EnumSelector',
        allowedValues: availableLoggerStatuses,
        useDropdown: true,
        required: true,
    },
    [UpdateField.DestinationLocation]: {
        name: 'updateTo',
        labelKey: 'BulkUpload.updateTo',
        componentName: 'LocationObjectSelector',
        required: true,
    },
}

const updateField: FieldInCard<keyof LoggerBulkUploadFormValues> = {
    name: 'update',
    labelKey: 'BulkUpload.update',
    componentName: 'EnumSelector',
    allowedValues: updateFieldValues,
    useDropdown: true,
    required: true,
}

export const getUpdateFormFields = (
    {
        updateToType,
    }: {
        updateToType: UpdateField | undefined,
    },
): UpdateFormFields<LoggerBulkUploadFormValues> => {
    const updateToField = updateToFieldMap[updateToType]

    const fields = [
        selectedRecordsField,
        updateField,
    ]

    if (updateToField) {
        fields.push(updateToField)
    }

    return [{
        title: '',
        fields,
    }]
}

export const getFeedbackFormFields = (
    {
        updateToType,
    }: {
        updateToType: UpdateField,
    },
): FeedbackFormFields<LoggerBulkUploadFormValues> => {
    return [{
        title: '',
        fields: [
            selectedRecordsField,
            updatedRecordsField,
            ...[
                updateField,
                updateToFieldMap[updateToType!],
            ].map((field) => {
                return {
                    ...field, disabled: true,
                }
            }),
        ],
    }]
}
